import { Link as _Link } from 'react-router-dom'
import styled from 'styled-components'

export const Link = styled(_Link)`
  display: inline-block;
  font-family: "SF Pro Display";
  font-size: 18px;
  color: #d57b20;
  text-decoration: underline;

  :focus, :hover, :active {
    color: #AD641A;
  }
`



// WEBPACK FOOTER //
// ./src/atoms/Link.tsx